const prefix = 'feature-';

const isOverride = ([key]) => key.startsWith(prefix) && key.length > prefix.length;
const removePrefix = ([key, value]) => [key.replace(prefix, ''), value];

exports.getQueryOverrides = (query = {}) => Object.fromEntries(
  Object.entries(query)
    .filter(isOverride)
    .map(removePrefix),
);

exports.PREFIX = prefix;
